import { render, staticRenderFns } from "./ProductConfiguratorEditorText.vue?vue&type=template&id=0cdbc15d&functional=true"
import script from "./ProductConfiguratorEditorText.vue?vue&type=script&lang=js"
export * from "./ProductConfiguratorEditorText.vue?vue&type=script&lang=js"
import style0 from "./ProductConfiguratorEditorText.vue?vue&type=style&index=0&id=0cdbc15d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports